<template>
  <div class="signatures-container">
    <div
      class="signatures"
      v-if="
        !(
          order.orderState == 10 ||
          (order.refundState == 10 && order.orderState == 50)
        ) && codeList.length > 0
      "
    >
      <div class="signatures-wrapper signatures-new">
        <div class="title">
          <p>核销</p>
        </div>
        <div class="dialog-qrcode">
          <p class="code">
            券码：
            <span id="success_form_input1">{{ showingCode.voucherNO }}</span>
            <button
              @click="copyText"
              ref="copyCode"
              :data-clipboard-text="showingCode.voucherNO"
              data-clipboard-target="#success_form_input1"
              class="copyText"
            >
              复制
            </button>
          </p>
        </div>
        <div class="swipe-layout">
          <p
            class="prev"
            @click="prevPage"
            v-if="codeList && codeList.length > 1"
          >
            <i class="iconfont icon-youjiantou icon-zuojiatoutou-extra"></i>
          </p>
          <div class="swipe-main">
            <mt-swipe
              :auto="0"
              :showIndicators="false"
              @change="handleChange"
              :defaultIndex="defaultIndex"
              ref="swipe"
            >
              <mt-swipe-item v-for="(item, index) in codeList" :key="index">
                <div class="swipe-item-ui">
                  <div class="code-barcode">
                    <img :src="item.imageUrl" />
                  </div>
                </div>
              </mt-swipe-item>
            </mt-swipe>
          </div>
          <p
            class="next"
            @click="nextPage"
            v-if="codeList && codeList.length > 1"
          >
            <i class="iconfont icon-youjiantou icon-youjiatoutou-extra"></i>
          </p>
        </div>
        <p class="warn">请凭手机短信或上方消费码/二维码验证使用</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Swipe, SwipeItem } from 'mint-ui'
export default {
  props: {
    codeList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      showIndex: 0,
      defaultIndex: 0,
      showingCode: this.codeList[0]
    }
  },
  components: {
    'mt-swipe': Swipe,
    'mt-swipe-item': SwipeItem
  },
  mounted() {
    if (this.$refs.copyCode) {
      this.copyCodeBtn = new this.$$clipboard(this.$refs.copyCode)
    }
  },
  methods: {
    copyText() {
      let _this = this
      let clipboard = _this.copyCodeBtn
      clipboard.on('success', function (e) {
        _this.$$toast('复制成功')
        return
      })
      clipboard.on('error', function (e) {
        window.prompt('复制失败，请手动复制', e.text)
      })
    },
    handleChange(index) {
      this.showIndex = index
      this.showingCode = this.codeList[this.showIndex]
      this.launchCheckStatus()
    },
    prevPage() {
      this.$refs.swipe.prev()
    },
    nextPage() {
      this.$refs.swipe.next()
    }
  },
  computed: {
    ...mapState(['order'])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin.scss';

.signatures-container {
  margin: rem(24px) rem(24px) rem(20px);
  border-radius: rem(16px);
  background-color: #ffffff;
  line-height: 1.2;
  font-size: rem(28px);
  .signatures-wrapper {
    padding: rem(40px) rem(24px) rem(18px);
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: rem(10px);
    font-size: rem(32px);
    font-weight: bold;
    color: #000000;

    .titleTip {
      font-size: rem(22px);
      font-weight: normal;
      color: #999999;
    }
  }
  .dialog-qrcode {
    margin: 0 auto;

    .qrcode-box {
      width: 2.7rem;
      height: 2.96rem;
      margin-top: 0;
      padding-top: 0.26rem;
      margin-bottom: 0.24rem;
    }

    .code {
      font-size: 0.26rem;
      color: #ff5900;
      line-height: 0.4rem;
      font-weight: 600;
      margin-bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .warn {
      font-size: 0.22rem;
      color: #262626;
      line-height: 0.28rem;
      margin-top: 0.16rem;
    }
  }
  .copyText {
    color: #ff5900;
    font-size: rem(20px);
    height: rem(32px);
    padding: 0 rem(12px);
    margin-left: rem(19px);
    border-radius: rem(16px);
    border: #ff5900 rem(1px) solid;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swipe-item-ui {
    height: 100%;
  }

  .code-barcode {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    height: 100%;
    text-align: center;
    & > img {
      height: rem(270px);
      width: rem(270px);
    }
  }

  .swipe-layout {
    background-color: #fff;
    height: rem(360px);
    display: flex;
    align-items: center;
    justify-content: center;
    .swipe-main {
      width: 70%;
      height: 100%;
    }
    & > p {
      width: 10%;
      text-align: center;
      i {
        color: #9b9c9b;
      }
    }
  }
  .indicators {
    background-color: #fff;
    text-align: center;
    color: #9b9c9b;
    span {
      color: #121112;
    }
  }
  .warn {
    font-size: 0.22rem;
    color: #262626;
    text-align: center;
    line-height: 0.28rem;
    margin-top: 0.16rem;
  }
}
.icon-youjiatoutou-extra {
  font-size: rem(48px);
  color: #262626 !important;
}

.icon-zuojiatoutou-extra {
  display: inline-block; //!!
  font-size: rem(48px);
  color: #262626 !important;
  transform: rotate(180deg);
}
</style>
